module.exports = __webpack_public_path__ + "static/media/insta2.1abc20d9.png";